import { AppBar, Box, Button, Card, CardHeader, Container, createStyles, Drawer, Grid, IconButton, List, ListItem, makeStyles, Paper, Theme, Toolbar, Typography } from "@material-ui/core";
import React, { useState, useEffect, useRef, useCallback, useImperativeHandle, forwardRef, ForwardRefRenderFunction, Dispatch, SetStateAction, Fragment } from "react";
import { oper as v_oper, basic, Values, material, order as v_order, SNACKBAR_TIME } from '../../request/values';
import { Waypoint } from "react-waypoint";

import NumberFormat from "react-number-format";

import clsx from 'clsx';

import { COLORS } from '../Theme'

// Icon

import Dialog, { DialogConfirm } from "../Dialog";
import { useSnackbar } from "notistack";
import axios from "axios";
import { SIcon } from "../Icon";
import { useHistory } from "react-router-dom";
import ToastStr from "../../request/toastStr";
import TitleBar from "../header/TitleBar";

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: 0,
            height: '88vh',
            width: '95vw',
            paddingTop: '3.5vh',
            background: `${COLORS.WHITE}`,
        },
        materialItem: {
            borderRadius: 12,
            margin: 'auto',
            marginBottom: '1.5vh',

            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
            width: '82vw',
            paddingTop: '2.2vh',
            paddingBottom: '2.2vh',
        },
        itemProcessing: {
            backgroundColor: `${COLORS.LIGHT_GREY}`
        },

        list: {
            width: '95vw',
            height: '75vh',
            overflowY: 'auto',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            fontSize: '4vw',
        },
        grid: {
            maxHeight: '80vh',
            overflowY: 'auto',
        },
        paper: {
            padding: theme.spacing(1),
            // margin: 'auto'
        },
        materialImage: {
            // height: 60,
            // width: 60
            textAlign: 'center',
            margin: 'auto',
            "& img": {
                width: '11vw',
            }
        },
        materialList: {
            width: '90%',
            maxWidth: 360,
        },
        materialCompanyName: {
            fontSize: '3vw',
            fontWeight: 'bold',
            fontFamily: 'NanumB',
            color: `${COLORS.WATER_BLUE}`,
        },
        orderSheet: {
            // height : 'calc(100%- 64px)',
            // top: 64
            height: "100vh"
        },
        empty: {
            height: '62vh',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            "& img": {
                width: "35vw",
                height: '35vw',
                marginBottom: '2.5vh',
                opacity: 0.4,
            },
            "& h1": {
                color: `${COLORS.DOWN}`,
            }
        },
        loanButton: {
            float: 'right',
            marginTop: '7%',
            borderRadius: '8px',
            backgroundColor: `${COLORS.WATER_BLUE}`,
            marginRight: '1vw',
        },
        loadButtonText: {
            color: `${COLORS.WHITE}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            fontSize: '3vw',
        },
    }),
);

export interface refHandle {
    refreshCartList: () => void,
    handleOpen: () => void
}

export interface InputProps {
    oper: any,
}

const OperProgress: ForwardRefRenderFunction<refHandle, InputProps> = ((props: any, ref: any) => {
    const classes = useStyles();
    const history = useHistory();

    const { oper } = props;

    const goNext = () => {
        history.push({
            pathname: '/operation/company/list/'
        });
    }

    return (
        <Container component="main" maxWidth="xs" className={classes.container}>
            <TitleBar history={history} title="기업관리" titleIcon="order" />


            <Box display="grid" justifyContent="center" alignItems="center" >
                <Typography variant="h1" align='center' style={{ color: `${COLORS.BROWNISH_GREY}` }}>정상적으로 처리되었습니다.</Typography>
                <List className={classes.list}>
                        <div className={classes.empty}>
                            <div>
                                <Button
                                    className={classes.loanButton}
                                    onClick={() => goNext()}
                                >
                                <Typography className={classes.loadButtonText}>메인페이지로</Typography>
                                </Button>
                                
                            </div>
                        </div>            
                </List>
            </Box>
        </Container>

    )
});

export default OperProgress;
